module.exports = __webpack_public_path__ + "img/img_sfzlr.1b4fc3ca.png";